import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  complianceData: {},
  parameters: [],
  totalParameters: 0,
  filtersLoading: false,
  filtersError: null,
  testTypes: [],
};

const parameterComplianceSlice = createSlice({
  name: "parameterCompliance",
  initialState,
  reducers: {
    fetchCompliance: (state, action) => {
      state.loading = true;
      state.error = null;
      state.complianceData = {};
      state.parameters =  [];
      state.totalParameters =  0;
    },
    fetchComplianceSuccess: (state, action) => {
      state.loading = false;
      state.complianceData = action.payload?.data || {};
      state.parameters = action.payload?.data?.parameters || [];
      state.totalParameters = action.payload?.data?.totalParameters || 0;
    },
    fetchComplianceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
   
    fetchFilters: (state, action) => {
      state.filtersLoading = true;
      state.filtersError = null;
    },
    fetchFiltersSuccess: (state, action) => {
      state.filtersLoading = false;
      const testTypesData = action.payload?.data?.document || action.payload?.document || [];
      state.testTypes = Array.isArray(testTypesData) ? testTypesData : [];
    },
    fetchFiltersFailure: (state, action) => {
      state.filtersLoading = false;
      state.filtersError = action.payload;
    },
    
    resetFilters: (state) => {
      state.testTypes = [];
      state.filtersError = null;
      state.filtersLoading = false;
    },
  },
});

export const { actions, reducer } = parameterComplianceSlice;
export const sliceKey = parameterComplianceSlice.name;